import { Lock } from "lucide-react";
import { ChapterEmblem } from "@/lib/brand";

// Cream / beige sealed thumbnail for chapters without official artwork.
// Warm luxury archive feel — never black, never neon.
export default function LockedChapter({ roman, restricted = false, size = "md", showLabel = true }) {
  const isLarge = size === "lg";
  return (
    <div className="relative w-full h-full overflow-hidden" data-testid={`locked-chapter-${roman}`}>
      {/* Warm cream/beige sealed room */}
      <div className="absolute inset-0" style={{
        background: restricted
          ? "radial-gradient(ellipse at 50% 30%, #e6d9be 0%, #d9c9a9 55%, #b9a380 100%)"
          : "radial-gradient(ellipse at 30% 20%, #efe7d3 0%, #e2d3b3 55%, #c9b48d 100%)"
      }} />
      {/* Soft directional light */}
      <div className="absolute inset-0" style={{
        background: "linear-gradient(115deg, transparent 30%, rgba(255,246,224,0.55) 45%, transparent 60%)",
      }} />
      {/* Very faint architectural line — champagne */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.18]" viewBox="0 0 400 500" preserveAspectRatio="none">
        <line x1="0" y1="180" x2="400" y2="220" stroke="#8b6f3d" strokeWidth="0.5" />
        <line x1="0" y1="320" x2="400" y2="360" stroke="#8b6f3d" strokeWidth="0.5" />
        <rect x="40" y="40" width="320" height="420" stroke="#8b6f3d" strokeWidth="0.5" fill="none" />
      </svg>
      {/* Grain */}
      <div className="grain opacity-30" />

      <div className="relative h-full flex flex-col items-center justify-center text-center p-8 z-10 text-[#5a4526]">
        <div className="opacity-40">
          <ChapterEmblem roman={roman} size={isLarge ? 64 : 44} stroke="currentColor" />
        </div>
        <p className={`font-editorial leading-none mt-6 opacity-55 ${isLarge ? "text-8xl md:text-9xl" : "text-6xl md:text-7xl"}`}>{roman}</p>
        {showLabel && (
          <div className="mt-8 flex items-center gap-2 opacity-70">
            <Lock className={isLarge ? "w-4 h-4" : "w-3 h-3"} strokeWidth={1.25} />
            <span className={`tracking-widest-plus uppercase ${isLarge ? "text-[11px]" : "text-[10px]"}`}>
              {restricted ? "Founder · Restricted" : "Reveal Pending"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
